import { Text, Box } from "@chakra-ui/react";

const PropertySearch = ({
    searchQuery,
    filterProperties,
    handleEntityClick,
}: {
    searchQuery: string;
    filterProperties: any;
    handleEntityClick: any;
}) => {
    return (
        <Box mt="20px" borderBottom="1px solid #E2E2E2">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <Text fontWeight={"600"} fontSize={"12px"} mb={"10px"}>
                        Properties
                    </Text>
                    {searchQuery ? (
                        filterProperties().length > 0 ? (
                            filterProperties().map((property: any) => (
                                <tr
                                    key={property.id}
                                    style={{
                                        display: "flex",
                                        cursor: "pointer",
                                        marginTop: "8px",
                                        width: "100%",
                                    }}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.style.backgroundColor = "#F9F8F8")
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.style.backgroundColor = "white")
                                    }
                                >
                                    <td
                                        style={{
                                            fontWeight: 500,
                                            width: "200px",
                                            maxWidth: "300px",
                                            color: "#302E34",
                                            wordWrap: "break-word",
                                            marginLeft: "8px",
                                            marginTop: "8px",
                                            marginBottom: "8px",
                                        }}
                                        onClick={() => handleEntityClick("properties", property.id)}
                                    >
                                        {property.name}
                                    </td>
                                    <td
                                        style={{
                                            fontWeight: 500,
                                            color: "#B6B3B9",
                                            width: "150px",
                                            paddingLeft: "70px",
                                            marginTop: "8px",
                                            marginBottom: "8px",
                                        }}
                                    >
                                        {property.address}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr style={{ height: "92px" }}>
                                <td colSpan={2}>
                                    <Text mt={"-15px"}>No properties matched.</Text>
                                </td>
                            </tr>
                        )
                    ) : (
                        <tr style={{ height: "92px" }}>
                            <td colSpan={2}>
                                <Text mt={"-10px"}>
                                    Enter a search query to find properties.
                                </Text>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Box>
    );
};

export default PropertySearch; 